// extracted by mini-css-extract-plugin
module.exports = {"root":"_35LnF","return":"_9xNHU","when":"_3vKuY","whenText":"_1ycgT","old":"_1K3TC","where":"_3nvyU"};